export const ContenedorBotones = ({
    procesos,
    setProcesoElegido,
    numeroProceso,
    procesoElegido
}) => {
    let infoProcesos = procesos.map( data =>({
        ...data,
        nroOrden: data.nroOrden.split(',').map(Number)
    }))
    let color = ['bg-gray-900','bg-gray-800','bg-gray-700','bg-gray-600','bg-gray-500','bg-gray-400','bg-gray-300','bg-gray-200','bg-gray-100',]
    const estiloFinalizado = 'bg-[#3b82f6] text-white procesoFinalizado';
    const estiloActual = 'bg-gray-500  text-white procesoPendiente '
    const estiloPendiente = ' opacity-50';
    const estiloElegido = 'bg-[#2563eb] font-semibold procesoFinalizado';
    return(
        <>
        {
            infoProcesos.map((p,i) => (
                <button
                    key={'btnProceso_' + p.codIncidenciaProceso}
                    className={`${p.nroOrden.some(nro  => procesoElegido === nro) ? estiloElegido : 
                    `${color[i]} ${p.nroOrden.every(nro => nro > numeroProceso) && estiloPendiente} disabled:cursor-not-allowed `}
                    ${p.nroOrden.some(nro => nro <= numeroProceso) ? ' hover:bg-[#8dbe55] ' : ''} w-full lg:w-[90px] lg:text-xs h-full rounded `}
                    disabled={
                        numeroProceso == 1 ? 
                            (p.nroOrden.some(nro => nro === 1 || nro === 4 || nro === 5) ? false : true)
                        :
                            (p.nroOrden.some( nro => nro <= numeroProceso ) ? false : true)
                    }
                    // onClick={(e) => p.numeroEstado <= numeroProceso ? setProcesoElegido(p.numeroEstado) : e.preventDefault()}
                    onClick={(e) => {
                        // if(p.nroOrden.some(nro => nro <= numeroProceso )){
                        //     setProcesoElegido(Math.min(...p.nroOrden))
                        //     return
                        // }
                        // e.preventDefault()
                        setProcesoElegido(Math.min(...p.nroOrden))
                    }}
                >{p.nomIncidenciaProceso}
                </button>
            ))
        }
        </>
    )
}